import isGriffinRequestSupported from '../../utils/featureChecks/isGriffinRequestSupported';
import makeGriffinServiceRequest from '../../services/makeGriffinServiceRequest';
import onRemoveFromCalendarClicked from '../../services/removeTxpEventsFromCalendar';
import {
    ADD_REMOVE_OR_EDIT_URL_PREFIX,
    REMOVE_FROM_CALENDAR_RELATIVEPATH,
} from '../../helpers/GriffinConstants';

/**
 * Handler for removing Txp event from calendar
 */
export default function onRemoveFromCalendarClickHandler(itemId: string) {
    return isGriffinRequestSupported()
        ? makeGriffinServiceRequest(
              itemId,
              ADD_REMOVE_OR_EDIT_URL_PREFIX,
              REMOVE_FROM_CALENDAR_RELATIVEPATH
          )
        : onRemoveFromCalendarClicked(itemId);
}
